// Booking State Alert schedule. A config either polls every N hours
// (schedule_mode 'interval', the original behaviour) or runs at fixed hours on
// chosen weekdays (schedule_mode 'fixed'), in the tenant's timezone. The
// Lambda fires on the hour, so times are whole hours. The day codes and mode
// values are what tbn_booking_state_alerts.py / cm_booking_state_alerts.py
// read - keep them in step.
export const DAY_OPTIONS = [
  { value: 'mon', text: 'Mon' },
  { value: 'tue', text: 'Tue' },
  { value: 'wed', text: 'Wed' },
  { value: 'thu', text: 'Thu' },
  { value: 'fri', text: 'Fri' },
  { value: 'sat', text: 'Sat' },
  { value: 'sun', text: 'Sun' },
]
export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri']

export const SCHEDULE_MODE_OPTIONS = [
  { value: 'interval', text: 'Every N hours' },
  { value: 'fixed', text: 'Fixed days and times' },
]

export function hourLabel(hour) {
  const h = Number(hour)
  const twelve = h % 12 === 0 ? 12 : h % 12
  return `${twelve}:00 ${h < 12 ? 'AM' : 'PM'}`
}

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => ({ value: String(h), text: hourLabel(h) }))

export function isFixedSchedule(config) {
  return (config || {}).schedule_mode === 'fixed'
}

// consecutive days collapse to a range ("Mon–Fri"); none or all seven read
// "Every day", matching the handler's treatment of an empty day list
export function dayRangeLabel(days) {
  const order = DAY_OPTIONS.map((d) => d.value)
  const picked = order.filter((d) => (days || []).includes(d))
  if (!picked.length || picked.length === 7) return 'Every day'
  const idx = picked.map((d) => order.indexOf(d))
  const label = (d) => DAY_OPTIONS[order.indexOf(d)].text
  const consecutive = idx.every((v, i) => i === 0 || v === idx[i - 1] + 1)
  if (consecutive && picked.length >= 3) return `${label(picked[0])}–${label(picked[picked.length - 1])}`
  return picked.map(label).join(', ')
}

function sortedHours(hours) {
  const valid = (hours || []).map(Number).filter((h) => Number.isInteger(h) && h >= 0 && h <= 23)
  return [...new Set(valid)].sort((a, b) => a - b)
}

// "Every 2 hrs" / "Mon–Fri at 12:00 PM" / "Mon, Wed at 6:00 AM, 4:00 PM"
export function describeBookingStateSchedule(config) {
  const c = config || {}
  if (!isFixedSchedule(c)) {
    const hrs = Number(c.poll_interval_hrs) || 2
    return hrs === 1 ? 'Every hour' : `Every ${hrs} hrs`
  }
  const hours = sortedHours(c.schedule_hours).map(hourLabel)
  if (!hours.length) return `${dayRangeLabel(c.schedule_days)}, no times set`
  return `${dayRangeLabel(c.schedule_days)} at ${hours.join(', ')}`
}

// recipients are typed free-form; commas and semicolons both separate
export function splitRecipients(raw) {
  return String(raw || '').split(/[;,]/).map((s) => s.trim()).filter(Boolean)
}
